import IndividualServicesContainer from './IndividualServicesPageContainer';

export default IndividualServicesContainer;



// WEBPACK FOOTER //
// ./src/components/pages/IndividualServicesPage/index.js